var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 640 640",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.5 209C352.1 218.4 336.9 218.4 327.6 209C318.3 199.6 318.2 184.4 327.6 175.1L431.5 71C440.9 61.6 456.1 61.6 465.4 71L569.4 175C578.8 184.4 578.8 199.6 569.4 208.9C560 218.2 544.8 218.3 535.5 208.9L472.5 145.9L472.5 552C472.5 565.3 461.8 576 448.5 576C435.2 576 424.5 565.3 424.5 552L424.5 145.9L361.5 208.9zM105.5 431L168.5 494L168.5 87.9C168.5 74.6 179.2 63.9 192.5 63.9C205.8 63.9 216.5 74.6 216.5 87.9L216.5 494L279.5 431C288.9 421.6 304.1 421.6 313.4 431C322.7 440.4 322.8 455.6 313.4 464.9L209.4 568.9C200 578.3 184.8 578.3 175.5 568.9L71.5 465C62.1 455.6 62.1 440.4 71.5 431.1C80.9 421.8 96.1 421.7 105.4 431.1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashTransfer);
export default __webpack_public_path__ + "static/media/cash-transfer.082e77e0b26219fd9716ce2c6d981811.svg";
export { ForwardRef as ReactComponent };